import React, { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { axiosInstance } from "../../axiosInstance";
import Preloader from "../../Components/Loader/Loader";
import signinLogo from "../../assets/images/login/signin-logo.png";
import { OtpInput } from "reactjs-otp-input";
import "./otp.css";

export function Otp() {
  const [otp, setOtp] = useState("");
  const [timer, setTimer] = useState(30);
  const [canResend, setCanResend] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // countdown timer
  useEffect(() => {
    let countdown;
    if (timer > 0) {
      countdown = setTimeout(() => setTimer((prev) => prev - 1), 1000);
    } else {
      setCanResend(true);
    }
    return () => clearTimeout(countdown);
  }, [timer]);

  // resend OTP
  const handleResend = async () => {
    setTimer(30);
    setCanResend(false);
    try {
      const mobile_number = localStorage.getItem("mobile_number");
      const temp_token = localStorage.getItem("temp_token");

      const response = await axiosInstance.post("/resend-otp/", {
        mobile_number,
        user_type: "agent",
        token: temp_token,
      });

      if (response.data.status === "success") {
        toast.success(response.data.message || "OTP resent successfully!");
      } else {
        toast.error(response.data.message || "Failed to resend OTP");
      }
    } catch (error) {
      console.error("Resend error:", error);
      toast.error("Something went wrong while resending OTP");
    }
  };

  // submit OTP
  const handleSubmit = async () => {
    if (!otp || otp.length < 4) {
      toast.error("Please enter a valid 4-digit OTP");
      return;
    }

    setLoading(true);
    try {
      const mobile_number = localStorage.getItem("mobile_number");
      const temp_token = localStorage.getItem("temp_token");

      const payload = {
        mobile_number,
        otp,
        user_type: "agent",
        token: temp_token,
      };

      // const response = await axiosInstance.post("/verify-otp/", payload);
      const response = await axiosInstance.post("/agent/verify-otp/", payload);

      if (response.data.status === "success") {
        toast.success(response.data.message || "OTP verified successfully!");

        // save final auth token
        // if (response.data.data?.token) {
        //   localStorage.setItem("token", response.data.data.token);
        //   localStorage.removeItem("temp_token"); // cleanup
        // }

        // setTimeout(() => {
        //   navigate("/home");
        // }, 1200);

        localStorage.removeItem("mobile_number");
        localStorage.removeItem("pending_verification_user");
        localStorage.removeItem("temp_token");

        setTimeout(() => {
          navigate("/");
        }, 1200);
      } else {
        const msg =
          response.data.message || "OTP verification failed. Please try again.";
        toast.error(msg);
      }
    } catch (error) {
      console.error("OTP verification error:", error);

      if (error.response?.data?.message) {
        toast.error(error.response.data.message);
      } else {
        toast.error("Something went wrong during OTP verification");
      }
    } finally {
      setLoading(false);
    }
  };

  // allow Enter key to submit
  // useEffect(() => {
  //   const handleKeyDown = (e) => {
  //     if (e.key === "Enter") {
  //       e.preventDefault();
  //       handleSubmit();
  //     }
  //   };
  //   document.addEventListener("keydown", handleKeyDown);
  //   return () => document.removeEventListener("keydown", handleKeyDown);
  // }, [otp]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Enter") {
        e.preventDefault();
        handleSubmit();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [handleSubmit]);

  return (
    <>
      {loading && <Preloader />}
      <ToastContainer />
      <div className="signin-container">
        <div className="signin-left">
          <div>
            <div className="signin-logo">
              <img src={signinLogo} alt="Signin Logo" />
            </div>
            <div className="signin-lefttext">
              Join the Gomak Referral Program and start earning rewards! Enter
              the OTP sent to your registered mobile number to verify your
              identity and continue.
            </div>
          </div>
        </div>

        <div className="signin-right">
          <div className="signin-formContainer">
            <div className="signin-title">Verify OTP</div>
            <div className="signin-subtitle">We sent a code to your mobile</div>

            <form
              onSubmit={(e) => {
                e.preventDefault();
                handleSubmit();
              }}
            >
              <div className="pinFieldContainer">
                {/* <PinField
                    length={4}
                    onChange={(value) => setOtp(value)}
                    validate="0123456789"
                    autoFocus
                    className="pinfieldNumbers"
                  /> */}
                <OtpInput
                  value={otp}
                  onChange={(val) => {
                    const digitsOnly = String(val)
                      .replace(/\D/g, "")
                      .slice(0, 4);
                    setOtp(digitsOnly);
                  }}
                  numInputs={4}
                  inputStyle={{
                    width: "48px",
                    height: "48px",
                    margin: "0 4px",
                    fontSize: "18px",
                    borderRadius: "6px",
                    border: "1px solid #ced4da",
                    outline: "none",
                    boxSizing: "border-box",
                    textAlign: "center",
                  }}
                  containerStyle={{ justifyContent: "center", display: "flex" }}
                  shouldAutoFocus={true}
                  isInputNum={true}
                />
              </div>

              <div>
                <span>Didn’t receive the code? </span>
                <button
                  type="button"
                  onClick={handleResend}
                  disabled={!canResend}
                  className="resend-btn"
                >
                  {canResend ? "Resend OTP" : `Resend in ${timer}s`}
                </button>
              </div>

              <div className="btnLogin">
                <button type="submit" disabled={loading}>
                  {loading ? "Verifying..." : "Submit"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
